/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');
    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  
  // InstantSearchResult.prototype.afterRender = function () {
  //   var self = this;
  //   console.log("Instant Search Result After Render", self);
  // }
  InstantSearchResult.prototype.afterRender = function () {
        var self = this;

        // Check if the search suggestion group is present
        const suggestionGroup = document.querySelector('.boost-pfs-search-suggestion-group');
        if (!suggestionGroup) {
            console.warn("'.boost-pfs-search-suggestion-group' not found.");
            return;
        }

        // Array of possible search input selectors
        const searchInputSelectors = [
            '#boost-pfs-search-box-0',
            '#boost-pfs-search-box-1',
            '#boost-pfs-search-box-2',
            '#boost-pfs-search-box-mobile',
            '#boost-pfs-search-box-style3'
        ];

        let searchTerm = null;

        // Iterate through the selectors to find the search input with a value
        searchInputSelectors.forEach(selector => {
            const searchInput = document.querySelector(selector);
            if (searchInput && searchInput.value) {
                searchTerm = searchInput.value;
                console.log("Search term detected:", searchTerm);

                // Fetch WordPress posts based on the search term
                fetchWordPressPosts(searchTerm, suggestionGroup);
            }
        });

        if (!searchTerm) {
            console.log("Search input or search term not found.");
        }
    };

    // Function to fetch WordPress posts
    function fetchWordPressPosts(searchTerm, suggestionGroup) {
        const wordPressApiUrl = `https://articles.anseladams.com/wp-json/wp/v2/posts?search=${encodeURIComponent(searchTerm)}`;
        console.log("Fetching from URL:", wordPressApiUrl);

        fetch(wordPressApiUrl)
            .then(response => response.json())
            .then(posts => {
                console.log("Received posts:", posts);
                if (posts.length > 0) {
                    // Append WordPress suggestions to the suggestion group
                    appendWordPressSuggestions(posts, suggestionGroup);
                } else {
                    console.log("No posts found for:", searchTerm);
                    clearWordPressSuggestions(suggestionGroup);
                }
            })
            .catch(error => {
                console.error("Error fetching WordPress posts:", error);
                //debugger; // Pause execution for debugging
            });
    }

    // Function to append WordPress suggestions
    function appendWordPressSuggestions(posts, suggestionGroup) {
        //console.log("Appending suggestions to '.boost-pfs-search-suggestion-group':", posts);

        // Clear previous WordPress suggestions
        clearWordPressSuggestions(suggestionGroup);

        // Create a container for WordPress suggestions
        const wordpressSuggestionsContainer = document.createElement('div');
        wordpressSuggestionsContainer.className = 'wordpress-suggestions';

        // Add a heading with the count of articles
        const heading = document.createElement('div');
        heading.className = 'wordpress-suggestions-heading';
        heading.textContent = `Articles (${posts.length})`; // Display the count of articles
        wordpressSuggestionsContainer.appendChild(heading);

        // Append each post as a suggestion
        posts.forEach(post => {
            //console.log("Appending post:", post.title.rendered);

            const suggestionItem = document.createElement('div');
            suggestionItem.className = 'boost-pfs-search-suggestion-item';
            suggestionItem.innerHTML = `
                <a href="${post.link}" target="_blank">
                    <span>${post.title.rendered}</span>
                </a>
            `;

            wordpressSuggestionsContainer.appendChild(suggestionItem);
        });

        // Append the WordPress suggestions to the suggestion group
        suggestionGroup.appendChild(wordpressSuggestionsContainer);
        suggestionGroup.style.display = 'block';
        //console.log("Suggestions appended successfully.");
    }

    // Function to clear WordPress suggestions
    function clearWordPressSuggestions(suggestionGroup) {
        //console.log("Clearing previous suggestions.");

        const existingSuggestions = suggestionGroup.querySelector('.wordpress-suggestions');
        if (existingSuggestions) {
            existingSuggestions.remove();
            //console.log("Previous suggestions removed.");
        } else {
            //console.log("No existing suggestions to remove.");
        }
    }

  // InstantSearchResultItemProduct.prototype.afterRender = function() {
  //   if (this.$element && this.data && this.data.price_min == 0) {
  //    this.$element.addClass("hide-price");
  //   }
  // }
   InstantSearchResultItemProduct.prototype.afterRender = function() {
  // 1. First collect all data (as before)
  if (!window.__searchResults) window.__searchResults = [];
  if (this.data) window.__searchResults.push(this.data);
  
  // 2. Check if product belongs to the special collection
  if (this.data && this.data.collections) {
    const isOriginalPhotograph = this.data.collections.some(
      collection => collection.handle === "original-photographs-by-ansel-adams"
    );
    
    // 3. Hide price if it's in the special collection
    if (isOriginalPhotograph && this.$element) {
      this.$element.addClass("hide-price");
      console.log('Hiding price for:', this.data.title);
    }
  }

  // 4. Original price check for free products
  if (this.$element && this.data && this.data.price_min === 0) {
    this.$element.addClass("hide-price");
  }

  // 5. Log complete results when done
  if (this.isLastItem) {
    console.log('All search results:', window.__searchResults);
    window.__searchResults = []; // Reset for next search
  }
};

})();